// import { authHeader } from './auth-header';
import Api from "./PreApiHandler";

export default {
    startDemoPeriod,
    getPayLink,
    getCountRequests,
    getCostCurrentMonth,
    getBillHistory,
    changeTariff,
    getPricingConfig,
};

async function startDemoPeriod(params) {
    const request = {
        method: 'post',
        path: 'user/billing/start-trial',
        params
    }

    return Api.sendRequest(request)
}

async function getPayLink(params) {
    const request = {
        method: 'post',
        path: 'user/billing/pay',
        params
    }

    return Api.sendRequest(request)
}

async function getCountRequests(params) {
    const request = {
        method: 'get',
        path: 'user/billing/get-count-requests',
        params
    }

    return Api.sendRequest(request)
}

async function getCostCurrentMonth(params) {
    const request = {
        method: 'get',
        path: 'user/billing/get-cost-current-month',
        params
    }

    return Api.sendRequest(request)
}

async function getBillHistory(params) {
    const request = {
        method: 'get',
        path: 'user/billing/get-bill-history',
        params
    }

    return Api.sendRequest(request)
}

async function changeTariff(params) {
    const request = {
        method: 'post',
        path: 'user/billing/change-tariff',
        params
    }

    return Api.sendRequest(request)
}

async function getPricingConfig() {
    const request = {
        method: 'get',
        path: 'user/billing/get-pricing-config',
    }

    return Api.sendRequest(request)
}
